import BookDemoButtonComponent, { IProps } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';
import config from '@evercall/config';
import { LogoEvercallStandart } from '@dealroadshow/uikit-logo/Evercall/Standart';

const BookDemoButton = (props: Omit<IProps, 'tenant'>) => (
  <BookDemoButtonComponent
    tenant={ config.code }
    logoComponent={ LogoEvercallStandart }
    { ...props }
  />
);

export default BookDemoButton;
